import $e, { forwardRef as ue, useRef as ie, useCallback as k, useMemo as br, useState as Ze, useEffect as _r } from "react";
import { noop as F, debounce as wr, isNil as Tr, isEmpty as T } from "lodash/fp";
import { Icon as D, Menu as Ue, Stack as G, Input as Sr, useScrollIntoView as Or, Container as We, Header as Pr, Content as Fe, Frame as Ne, H4 as Ae, Text as Mr, Modal as kr } from "@kinesis/bungle";
import { useTheme as Dr } from "styled-components";
var ce = { exports: {} }, W = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Le;
function Zr() {
  if (Le)
    return W;
  Le = 1;
  var g = $e, C = Symbol.for("react.element"), o = Symbol.for("react.fragment"), d = Object.prototype.hasOwnProperty, c = g.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function u(h, p, v) {
    var y, b = {}, S = null, A = null;
    v !== void 0 && (S = "" + v), p.key !== void 0 && (S = "" + p.key), p.ref !== void 0 && (A = p.ref);
    for (y in p)
      d.call(p, y) && !s.hasOwnProperty(y) && (b[y] = p[y]);
    if (h && h.defaultProps)
      for (y in p = h.defaultProps, p)
        b[y] === void 0 && (b[y] = p[y]);
    return { $$typeof: C, type: h, key: S, ref: A, props: b, _owner: c.current };
  }
  return W.Fragment = o, W.jsx = u, W.jsxs = u, W;
}
var N = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ie;
function Fr() {
  return Ie || (Ie = 1, process.env.NODE_ENV !== "production" && function() {
    var g = $e, C = Symbol.for("react.element"), o = Symbol.for("react.portal"), d = Symbol.for("react.fragment"), c = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), u = Symbol.for("react.provider"), h = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), v = Symbol.for("react.suspense"), y = Symbol.for("react.suspense_list"), b = Symbol.for("react.memo"), S = Symbol.for("react.lazy"), A = Symbol.for("react.offscreen"), H = Symbol.iterator, J = "@@iterator";
    function K(e) {
      if (e === null || typeof e != "object")
        return null;
      var r = H && e[H] || e[J];
      return typeof r == "function" ? r : null;
    }
    var x = g.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function E(e) {
      {
        for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
          n[a - 1] = arguments[a];
        O("error", e, n);
      }
    }
    function O(e, r, n) {
      {
        var a = x.ReactDebugCurrentFrame, f = a.getStackAddendum();
        f !== "" && (r += "%s", n = n.concat([f]));
        var m = n.map(function(l) {
          return String(l);
        });
        m.unshift("Warning: " + r), Function.prototype.apply.call(console[e], console, m);
      }
    }
    var X = !1, qe = !1, ze = !1, Ge = !1, Je = !1, le;
    le = Symbol.for("react.module.reference");
    function Ke(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === d || e === s || Je || e === c || e === v || e === y || Ge || e === A || X || qe || ze || typeof e == "object" && e !== null && (e.$$typeof === S || e.$$typeof === b || e.$$typeof === u || e.$$typeof === h || e.$$typeof === p || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === le || e.getModuleId !== void 0));
    }
    function Xe(e, r, n) {
      var a = e.displayName;
      if (a)
        return a;
      var f = r.displayName || r.name || "";
      return f !== "" ? n + "(" + f + ")" : n;
    }
    function fe(e) {
      return e.displayName || "Context";
    }
    function P(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && E("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case d:
          return "Fragment";
        case o:
          return "Portal";
        case s:
          return "Profiler";
        case c:
          return "StrictMode";
        case v:
          return "Suspense";
        case y:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case h:
            var r = e;
            return fe(r) + ".Consumer";
          case u:
            var n = e;
            return fe(n._context) + ".Provider";
          case p:
            return Xe(e, e.render, "ForwardRef");
          case b:
            var a = e.displayName || null;
            return a !== null ? a : P(e.type) || "Memo";
          case S: {
            var f = e, m = f._payload, l = f._init;
            try {
              return P(l(m));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Z = Object.assign, $ = 0, de, pe, Ce, he, ve, me, ge;
    function ye() {
    }
    ye.__reactDisabledLog = !0;
    function Qe() {
      {
        if ($ === 0) {
          de = console.log, pe = console.info, Ce = console.warn, he = console.error, ve = console.group, me = console.groupCollapsed, ge = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: ye,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        $++;
      }
    }
    function er() {
      {
        if ($--, $ === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Z({}, e, {
              value: de
            }),
            info: Z({}, e, {
              value: pe
            }),
            warn: Z({}, e, {
              value: Ce
            }),
            error: Z({}, e, {
              value: he
            }),
            group: Z({}, e, {
              value: ve
            }),
            groupCollapsed: Z({}, e, {
              value: me
            }),
            groupEnd: Z({}, e, {
              value: ge
            })
          });
        }
        $ < 0 && E("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Q = x.ReactCurrentDispatcher, ee;
    function Y(e, r, n) {
      {
        if (ee === void 0)
          try {
            throw Error();
          } catch (f) {
            var a = f.stack.trim().match(/\n( *(at )?)/);
            ee = a && a[1] || "";
          }
        return `
` + ee + e;
      }
    }
    var re = !1, V;
    {
      var rr = typeof WeakMap == "function" ? WeakMap : Map;
      V = new rr();
    }
    function xe(e, r) {
      if (!e || re)
        return "";
      {
        var n = V.get(e);
        if (n !== void 0)
          return n;
      }
      var a;
      re = !0;
      var f = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var m;
      m = Q.current, Q.current = null, Qe();
      try {
        if (r) {
          var l = function() {
            throw Error();
          };
          if (Object.defineProperty(l.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(l, []);
            } catch (M) {
              a = M;
            }
            Reflect.construct(e, [], l);
          } else {
            try {
              l.call();
            } catch (M) {
              a = M;
            }
            e.call(l.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (M) {
            a = M;
          }
          e();
        }
      } catch (M) {
        if (M && a && typeof M.stack == "string") {
          for (var i = M.stack.split(`
`), _ = a.stack.split(`
`), j = i.length - 1, R = _.length - 1; j >= 1 && R >= 0 && i[j] !== _[R]; )
            R--;
          for (; j >= 1 && R >= 0; j--, R--)
            if (i[j] !== _[R]) {
              if (j !== 1 || R !== 1)
                do
                  if (j--, R--, R < 0 || i[j] !== _[R]) {
                    var w = `
` + i[j].replace(" at new ", " at ");
                    return e.displayName && w.includes("<anonymous>") && (w = w.replace("<anonymous>", e.displayName)), typeof e == "function" && V.set(e, w), w;
                  }
                while (j >= 1 && R >= 0);
              break;
            }
        }
      } finally {
        re = !1, Q.current = m, er(), Error.prepareStackTrace = f;
      }
      var I = e ? e.displayName || e.name : "", De = I ? Y(I) : "";
      return typeof e == "function" && V.set(e, De), De;
    }
    function tr(e, r, n) {
      return xe(e, !1);
    }
    function nr(e) {
      var r = e.prototype;
      return !!(r && r.isReactComponent);
    }
    function B(e, r, n) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return xe(e, nr(e));
      if (typeof e == "string")
        return Y(e);
      switch (e) {
        case v:
          return Y("Suspense");
        case y:
          return Y("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case p:
            return tr(e.render);
          case b:
            return B(e.type, r, n);
          case S: {
            var a = e, f = a._payload, m = a._init;
            try {
              return B(m(f), r, n);
            } catch {
            }
          }
        }
      return "";
    }
    var q = Object.prototype.hasOwnProperty, Ee = {}, je = x.ReactDebugCurrentFrame;
    function z(e) {
      if (e) {
        var r = e._owner, n = B(e.type, e._source, r ? r.type : null);
        je.setExtraStackFrame(n);
      } else
        je.setExtraStackFrame(null);
    }
    function ar(e, r, n, a, f) {
      {
        var m = Function.call.bind(q);
        for (var l in e)
          if (m(e, l)) {
            var i = void 0;
            try {
              if (typeof e[l] != "function") {
                var _ = Error((a || "React class") + ": " + n + " type `" + l + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[l] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw _.name = "Invariant Violation", _;
              }
              i = e[l](r, l, a, n, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (j) {
              i = j;
            }
            i && !(i instanceof Error) && (z(f), E("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", a || "React class", n, l, typeof i), z(null)), i instanceof Error && !(i.message in Ee) && (Ee[i.message] = !0, z(f), E("Failed %s type: %s", n, i.message), z(null));
          }
      }
    }
    var or = Array.isArray;
    function te(e) {
      return or(e);
    }
    function sr(e) {
      {
        var r = typeof Symbol == "function" && Symbol.toStringTag, n = r && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return n;
      }
    }
    function ir(e) {
      try {
        return Re(e), !1;
      } catch {
        return !0;
      }
    }
    function Re(e) {
      return "" + e;
    }
    function be(e) {
      if (ir(e))
        return E("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", sr(e)), Re(e);
    }
    var U = x.ReactCurrentOwner, cr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, _e, we, ne;
    ne = {};
    function ur(e) {
      if (q.call(e, "ref")) {
        var r = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function lr(e) {
      if (q.call(e, "key")) {
        var r = Object.getOwnPropertyDescriptor(e, "key").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function fr(e, r) {
      if (typeof e.ref == "string" && U.current && r && U.current.stateNode !== r) {
        var n = P(U.current.type);
        ne[n] || (E('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', P(U.current.type), e.ref), ne[n] = !0);
      }
    }
    function dr(e, r) {
      {
        var n = function() {
          _e || (_e = !0, E("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        n.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: n,
          configurable: !0
        });
      }
    }
    function pr(e, r) {
      {
        var n = function() {
          we || (we = !0, E("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        n.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: n,
          configurable: !0
        });
      }
    }
    var Cr = function(e, r, n, a, f, m, l) {
      var i = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: C,
        // Built-in properties that belong on the element
        type: e,
        key: r,
        ref: n,
        props: l,
        // Record the component responsible for creating this element.
        _owner: m
      };
      return i._store = {}, Object.defineProperty(i._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(i, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: a
      }), Object.defineProperty(i, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: f
      }), Object.freeze && (Object.freeze(i.props), Object.freeze(i)), i;
    };
    function hr(e, r, n, a, f) {
      {
        var m, l = {}, i = null, _ = null;
        n !== void 0 && (be(n), i = "" + n), lr(r) && (be(r.key), i = "" + r.key), ur(r) && (_ = r.ref, fr(r, f));
        for (m in r)
          q.call(r, m) && !cr.hasOwnProperty(m) && (l[m] = r[m]);
        if (e && e.defaultProps) {
          var j = e.defaultProps;
          for (m in j)
            l[m] === void 0 && (l[m] = j[m]);
        }
        if (i || _) {
          var R = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          i && dr(l, R), _ && pr(l, R);
        }
        return Cr(e, i, _, f, a, U.current, l);
      }
    }
    var ae = x.ReactCurrentOwner, Te = x.ReactDebugCurrentFrame;
    function L(e) {
      if (e) {
        var r = e._owner, n = B(e.type, e._source, r ? r.type : null);
        Te.setExtraStackFrame(n);
      } else
        Te.setExtraStackFrame(null);
    }
    var oe;
    oe = !1;
    function se(e) {
      return typeof e == "object" && e !== null && e.$$typeof === C;
    }
    function Se() {
      {
        if (ae.current) {
          var e = P(ae.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function vr(e) {
      {
        if (e !== void 0) {
          var r = e.fileName.replace(/^.*[\\\/]/, ""), n = e.lineNumber;
          return `

Check your code at ` + r + ":" + n + ".";
        }
        return "";
      }
    }
    var Oe = {};
    function mr(e) {
      {
        var r = Se();
        if (!r) {
          var n = typeof e == "string" ? e : e.displayName || e.name;
          n && (r = `

Check the top-level render call using <` + n + ">.");
        }
        return r;
      }
    }
    function Pe(e, r) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var n = mr(r);
        if (Oe[n])
          return;
        Oe[n] = !0;
        var a = "";
        e && e._owner && e._owner !== ae.current && (a = " It was passed a child from " + P(e._owner.type) + "."), L(e), E('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', n, a), L(null);
      }
    }
    function Me(e, r) {
      {
        if (typeof e != "object")
          return;
        if (te(e))
          for (var n = 0; n < e.length; n++) {
            var a = e[n];
            se(a) && Pe(a, r);
          }
        else if (se(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var f = K(e);
          if (typeof f == "function" && f !== e.entries)
            for (var m = f.call(e), l; !(l = m.next()).done; )
              se(l.value) && Pe(l.value, r);
        }
      }
    }
    function gr(e) {
      {
        var r = e.type;
        if (r == null || typeof r == "string")
          return;
        var n;
        if (typeof r == "function")
          n = r.propTypes;
        else if (typeof r == "object" && (r.$$typeof === p || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        r.$$typeof === b))
          n = r.propTypes;
        else
          return;
        if (n) {
          var a = P(r);
          ar(n, e.props, "prop", a, e);
        } else if (r.PropTypes !== void 0 && !oe) {
          oe = !0;
          var f = P(r);
          E("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", f || "Unknown");
        }
        typeof r.getDefaultProps == "function" && !r.getDefaultProps.isReactClassApproved && E("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function yr(e) {
      {
        for (var r = Object.keys(e.props), n = 0; n < r.length; n++) {
          var a = r[n];
          if (a !== "children" && a !== "key") {
            L(e), E("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", a), L(null);
            break;
          }
        }
        e.ref !== null && (L(e), E("Invalid attribute `ref` supplied to `React.Fragment`."), L(null));
      }
    }
    function ke(e, r, n, a, f, m) {
      {
        var l = Ke(e);
        if (!l) {
          var i = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (i += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var _ = vr(f);
          _ ? i += _ : i += Se();
          var j;
          e === null ? j = "null" : te(e) ? j = "array" : e !== void 0 && e.$$typeof === C ? (j = "<" + (P(e.type) || "Unknown") + " />", i = " Did you accidentally export a JSX literal instead of a component?") : j = typeof e, E("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", j, i);
        }
        var R = hr(e, r, n, f, m);
        if (R == null)
          return R;
        if (l) {
          var w = r.children;
          if (w !== void 0)
            if (a)
              if (te(w)) {
                for (var I = 0; I < w.length; I++)
                  Me(w[I], e);
                Object.freeze && Object.freeze(w);
              } else
                E("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Me(w, e);
        }
        return e === d ? yr(R) : gr(R), R;
      }
    }
    function xr(e, r, n) {
      return ke(e, r, n, !0);
    }
    function Er(e, r, n) {
      return ke(e, r, n, !1);
    }
    var jr = Er, Rr = xr;
    N.Fragment = d, N.jsx = jr, N.jsxs = Rr;
  }()), N;
}
process.env.NODE_ENV === "production" ? ce.exports = Zr() : ce.exports = Fr();
var t = ce.exports;
const He = (g) => {
  switch (g) {
    case "city":
      return "CCAP City";
    case "integrated":
      return "CCAP Integrated";
    case "workspace":
      return "Workspaces";
    case "inventory":
      return "Net-zero for Organisations";
    case "dataset":
      return "Datasets";
    case "pathways":
      return "Net-zero Pathways";
    case "settings":
      return "Settings";
    case "bill-management":
      return "Bill management";
  }
}, Ye = (g) => {
  const { namespace: C } = g, o = Dr();
  switch (C) {
    case "city":
      return /* @__PURE__ */ t.jsx(D, { type: "custom", magnitude: "small", color: "#E33444", children: /* @__PURE__ */ t.jsxs("svg", { viewBox: "0 0 1024 1024", children: [
        /* @__PURE__ */ t.jsx("path", { d: "M230.4 312.32C230.4 284.043 207.477 261.12 179.2 261.12C150.923 261.12 128 284.043 128 312.32C128 340.597 150.923 363.52 179.2 363.52C207.477 363.52 230.4 340.597 230.4 312.32Z" }),
        /* @__PURE__ */ t.jsx("path", { d: "M363.52 312.32C363.52 284.043 340.597 261.12 312.32 261.12C284.043 261.12 261.12 284.043 261.12 312.32C261.12 340.597 284.043 363.52 312.32 363.52C340.597 363.52 363.52 340.597 363.52 312.32Z" }),
        /* @__PURE__ */ t.jsx("path", { d: "M363.52 179.2C363.52 150.923 340.597 128 312.32 128C284.043 128 261.12 150.923 261.12 179.2C261.12 207.477 284.043 230.4 312.32 230.4C340.597 230.4 363.52 207.477 363.52 179.2Z" }),
        /* @__PURE__ */ t.jsx("path", { d: "M230.4 445.44C230.4 417.163 207.477 394.24 179.2 394.24C150.923 394.24 128 417.163 128 445.44C128 473.717 150.923 496.64 179.2 496.64C207.477 496.64 230.4 473.717 230.4 445.44Z" }),
        /* @__PURE__ */ t.jsx("path", { d: "M363.52 445.44C363.52 417.163 340.597 394.24 312.32 394.24C284.043 394.24 261.12 417.163 261.12 445.44C261.12 473.717 284.043 496.64 312.32 496.64C340.597 496.64 363.52 473.717 363.52 445.44Z" }),
        /* @__PURE__ */ t.jsx("path", { d: "M629.76 445.44C629.76 417.163 606.837 394.24 578.56 394.24C550.283 394.24 527.36 417.163 527.36 445.44C527.36 473.717 550.283 496.64 578.56 496.64C606.837 496.64 629.76 473.717 629.76 445.44Z" }),
        /* @__PURE__ */ t.jsx("path", { d: "M230.4 578.56C230.4 550.283 207.477 527.36 179.2 527.36C150.923 527.36 128 550.283 128 578.56C128 606.837 150.923 629.76 179.2 629.76C207.477 629.76 230.4 606.837 230.4 578.56Z" }),
        /* @__PURE__ */ t.jsx("path", { d: "M363.52 578.56C363.52 550.283 340.597 527.36 312.32 527.36C284.043 527.36 261.12 550.283 261.12 578.56C261.12 606.837 284.043 629.76 312.32 629.76C340.597 629.76 363.52 606.837 363.52 578.56Z" }),
        /* @__PURE__ */ t.jsx("path", { d: "M496.64 578.56C496.64 550.283 473.717 527.36 445.44 527.36C417.163 527.36 394.24 550.283 394.24 578.56C394.24 606.837 417.163 629.76 445.44 629.76C473.717 629.76 496.64 606.837 496.64 578.56Z" }),
        /* @__PURE__ */ t.jsx("path", { d: "M629.76 578.56C629.76 550.283 606.837 527.36 578.56 527.36C550.283 527.36 527.36 550.283 527.36 578.56C527.36 606.837 550.283 629.76 578.56 629.76C606.837 629.76 629.76 606.837 629.76 578.56Z" }),
        /* @__PURE__ */ t.jsx("path", { d: "M762.88 445.44C762.88 417.163 739.957 394.24 711.68 394.24C683.403 394.24 660.48 417.163 660.48 445.44C660.48 473.717 683.403 496.64 711.68 496.64C739.957 496.64 762.88 473.717 762.88 445.44Z" }),
        /* @__PURE__ */ t.jsx("path", { d: "M762.88 578.56C762.88 550.283 739.957 527.36 711.68 527.36C683.403 527.36 660.48 550.283 660.48 578.56C660.48 606.837 683.403 629.76 711.68 629.76C739.957 629.76 762.88 606.837 762.88 578.56Z" }),
        /* @__PURE__ */ t.jsx("path", { d: "M230.4 711.68C230.4 683.403 207.477 660.48 179.2 660.48C150.923 660.48 128 683.403 128 711.68C128 739.957 150.923 762.88 179.2 762.88C207.477 762.88 230.4 739.957 230.4 711.68Z" }),
        /* @__PURE__ */ t.jsx("path", { d: "M363.52 711.68C363.52 683.403 340.597 660.48 312.32 660.48C284.043 660.48 261.12 683.403 261.12 711.68C261.12 739.957 284.043 762.88 312.32 762.88C340.597 762.88 363.52 739.957 363.52 711.68Z" }),
        /* @__PURE__ */ t.jsx("path", { d: "M496.64 711.68C496.64 683.403 473.717 660.48 445.44 660.48C417.163 660.48 394.24 683.403 394.24 711.68C394.24 739.957 417.163 762.88 445.44 762.88C473.717 762.88 496.64 739.957 496.64 711.68Z" }),
        /* @__PURE__ */ t.jsx("path", { d: "M629.76 711.68C629.76 683.403 606.837 660.48 578.56 660.48C550.283 660.48 527.36 683.403 527.36 711.68C527.36 739.957 550.283 762.88 578.56 762.88C606.837 762.88 629.76 739.957 629.76 711.68Z" }),
        /* @__PURE__ */ t.jsx("path", { d: "M762.88 711.68C762.88 683.403 739.957 660.48 711.68 660.48C683.403 660.48 660.48 683.403 660.48 711.68C660.48 739.957 683.403 762.88 711.68 762.88C739.957 762.88 762.88 739.957 762.88 711.68Z" }),
        /* @__PURE__ */ t.jsx("path", { d: "M896 445.44C896 417.163 873.077 394.24 844.8 394.24C816.523 394.24 793.6 417.163 793.6 445.44C793.6 473.717 816.523 496.64 844.8 496.64C873.077 496.64 896 473.717 896 445.44Z" }),
        /* @__PURE__ */ t.jsx("path", { d: "M896 578.56C896 550.283 873.077 527.36 844.8 527.36C816.523 527.36 793.6 550.283 793.6 578.56C793.6 606.837 816.523 629.76 844.8 629.76C873.077 629.76 896 606.837 896 578.56Z" }),
        /* @__PURE__ */ t.jsx("path", { d: "M896 711.68C896 683.403 873.077 660.48 844.8 660.48C816.523 660.48 793.6 683.403 793.6 711.68C793.6 739.957 816.523 762.88 844.8 762.88C873.077 762.88 896 739.957 896 711.68Z" }),
        /* @__PURE__ */ t.jsx("path", { d: "M230.4 844.8C230.4 816.523 207.477 793.6 179.2 793.6C150.923 793.6 128 816.523 128 844.8C128 873.077 150.923 896 179.2 896C207.477 896 230.4 873.077 230.4 844.8Z" }),
        /* @__PURE__ */ t.jsx("path", { d: "M363.52 844.8C363.52 816.523 340.597 793.6 312.32 793.6C284.043 793.6 261.12 816.523 261.12 844.8C261.12 873.077 284.043 896 312.32 896C340.597 896 363.52 873.077 363.52 844.8Z" }),
        /* @__PURE__ */ t.jsx("path", { d: "M496.64 844.8C496.64 816.523 473.717 793.6 445.44 793.6C417.163 793.6 394.24 816.523 394.24 844.8C394.24 873.077 417.163 896 445.44 896C473.717 896 496.64 873.077 496.64 844.8Z" }),
        /* @__PURE__ */ t.jsx("path", { d: "M629.76 844.8C629.76 816.523 606.837 793.6 578.56 793.6C550.283 793.6 527.36 816.523 527.36 844.8C527.36 873.077 550.283 896 578.56 896C606.837 896 629.76 873.077 629.76 844.8Z" }),
        /* @__PURE__ */ t.jsx("path", { d: "M762.88 844.8C762.88 816.523 739.957 793.6 711.68 793.6C683.403 793.6 660.48 816.523 660.48 844.8C660.48 873.077 683.403 896 711.68 896C739.957 896 762.88 873.077 762.88 844.8Z" }),
        /* @__PURE__ */ t.jsx("path", { d: "M896 844.8C896 816.523 873.077 793.6 844.8 793.6C816.523 793.6 793.6 816.523 793.6 844.8C793.6 873.077 816.523 896 844.8 896C873.077 896 896 873.077 896 844.8Z" })
      ] }) });
    case "integrated":
      return /* @__PURE__ */ t.jsx(D, { type: "custom", magnitude: "small", color: "#263250", children: /* @__PURE__ */ t.jsxs(
        "svg",
        {
          width: "1024",
          height: "1024",
          viewBox: "0 0 1024 1024",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            /* @__PURE__ */ t.jsx("path", { d: "M496.64 578.56C496.64 550.283 473.717 527.36 445.44 527.36C417.163 527.36 394.24 550.283 394.24 578.56C394.24 606.837 417.163 629.76 445.44 629.76C473.717 629.76 496.64 606.837 496.64 578.56Z" }),
            /* @__PURE__ */ t.jsx("path", { d: "M629.76 578.56C629.76 550.283 606.837 527.36 578.56 527.36C550.283 527.36 527.36 550.283 527.36 578.56C527.36 606.837 550.283 629.76 578.56 629.76C606.837 629.76 629.76 606.837 629.76 578.56Z" }),
            /* @__PURE__ */ t.jsx("path", { d: "M762.88 445.44C762.88 417.163 739.957 394.24 711.68 394.24C683.403 394.24 660.48 417.163 660.48 445.44C660.48 473.717 683.403 496.64 711.68 496.64C739.957 496.64 762.88 473.717 762.88 445.44Z" }),
            /* @__PURE__ */ t.jsx("path", { d: "M762.88 578.56C762.88 550.283 739.957 527.36 711.68 527.36C683.403 527.36 660.48 550.283 660.48 578.56C660.48 606.837 683.403 629.76 711.68 629.76C739.957 629.76 762.88 606.837 762.88 578.56Z" }),
            /* @__PURE__ */ t.jsx("path", { d: "M230.4 711.68C230.4 683.403 207.477 660.48 179.2 660.48C150.923 660.48 128 683.403 128 711.68C128 739.957 150.923 762.88 179.2 762.88C207.477 762.88 230.4 739.957 230.4 711.68Z" }),
            /* @__PURE__ */ t.jsx("path", { d: "M363.52 711.68C363.52 683.403 340.597 660.48 312.32 660.48C284.043 660.48 261.12 683.403 261.12 711.68C261.12 739.957 284.043 762.88 312.32 762.88C340.597 762.88 363.52 739.957 363.52 711.68Z" }),
            /* @__PURE__ */ t.jsx("path", { d: "M496.64 711.68C496.64 683.403 473.717 660.48 445.44 660.48C417.163 660.48 394.24 683.403 394.24 711.68C394.24 739.957 417.163 762.88 445.44 762.88C473.717 762.88 496.64 739.957 496.64 711.68Z" }),
            /* @__PURE__ */ t.jsx("path", { d: "M629.76 711.68C629.76 683.403 606.837 660.48 578.56 660.48C550.283 660.48 527.36 683.403 527.36 711.68C527.36 739.957 550.283 762.88 578.56 762.88C606.837 762.88 629.76 739.957 629.76 711.68Z" }),
            /* @__PURE__ */ t.jsx("path", { d: "M896 445.44C896 417.163 873.077 394.24 844.8 394.24C816.523 394.24 793.6 417.163 793.6 445.44C793.6 473.717 816.523 496.64 844.8 496.64C873.077 496.64 896 473.717 896 445.44Z" }),
            /* @__PURE__ */ t.jsx("path", { d: "M896 578.56C896 550.283 873.077 527.36 844.8 527.36C816.523 527.36 793.6 550.283 793.6 578.56C793.6 606.837 816.523 629.76 844.8 629.76C873.077 629.76 896 606.837 896 578.56Z" }),
            /* @__PURE__ */ t.jsx("path", { d: "M230.4 844.8C230.4 816.523 207.477 793.6 179.2 793.6C150.923 793.6 128 816.523 128 844.8C128 873.077 150.923 896 179.2 896C207.477 896 230.4 873.077 230.4 844.8Z" }),
            /* @__PURE__ */ t.jsx("path", { d: "M363.52 844.8C363.52 816.523 340.597 793.6 312.32 793.6C284.043 793.6 261.12 816.523 261.12 844.8C261.12 873.077 284.043 896 312.32 896C340.597 896 363.52 873.077 363.52 844.8Z" })
          ]
        }
      ) });
    case "workspace":
      return /* @__PURE__ */ t.jsx(D, { type: "map-filled", magnitude: "small", color: "#932385" });
    case "inventory":
      return /* @__PURE__ */ t.jsx(D, { type: "custom", magnitude: "small", color: "#3BBEBE", children: /* @__PURE__ */ t.jsx("svg", { viewBox: "0 0 1024 1024", children: /* @__PURE__ */ t.jsx("path", { d: "M926 860H94C76.3 860 62 845.7 62 828V188C62 170.3 76.3 156 94 156H926C943.7 156 958 170.3 958 188V828C958 845.7 943.7 860 926 860ZM833.7 665.6L536.7 368.4C535.196 366.911 533.166 366.076 531.05 366.076C528.934 366.076 526.904 366.911 525.4 368.4L410.9 482.9L238.4 310.3C236.896 308.811 234.866 307.976 232.75 307.976C230.634 307.976 228.604 308.811 227.1 310.3L190.3 347.1C188.811 348.604 187.976 350.634 187.976 352.75C187.976 354.866 188.811 356.896 190.3 358.4L405.2 573.4C408.3 576.5 413.4 576.5 416.5 573.4L531 459L785.5 713.6C788.6 716.7 793.7 716.7 796.8 713.6L833.6 676.8C836.8 673.8 836.8 668.7 833.7 665.6Z" }) }) });
    case "dataset":
      return /* @__PURE__ */ t.jsx(D, { type: "datasets", magnitude: "small" });
    case "bill-management":
      return /* @__PURE__ */ t.jsx(D, { type: "datasets", magnitude: "small", color: o.color.gray7 });
    case "pathways":
      return /* @__PURE__ */ t.jsx(D, { type: "waterfall-filled", magnitude: "small", color: "#F7AF37" });
    case "settings":
      return /* @__PURE__ */ t.jsx(
        D,
        {
          type: "setting-filled",
          magnitude: "small",
          color: o.color.gray7
        }
      );
    default:
      return null;
  }
}, Ve = ue((g, C) => {
  const { name: o, namespace: d, href: c, focused: s, onHover: u = F } = g;
  return /* @__PURE__ */ t.jsx(
    Ue.Item,
    {
      ref: C,
      as: "a",
      href: c,
      target: "_parent",
      icon: /* @__PURE__ */ t.jsx(Ye, { namespace: d }),
      content: o,
      secondary: He(d),
      variant: s ? "focused" : "default",
      onMouseOver: u
    }
  );
}), Ar = (g) => {
  const {
    entityList: C,
    selectedEntity: o = 0,
    getEntityUrl: d = () => "",
    onHover: c = F
  } = g;
  return /* @__PURE__ */ t.jsx(G, { space: "none", children: C.map((s, u) => /* @__PURE__ */ t.jsx(
    Ve,
    {
      id: s.id,
      name: s.name,
      namespace: s.namespace,
      focused: o === u,
      href: d(s.namespace, s.id),
      onHover: () => c(u)
    },
    `${s.namespace}/${s.id}`
  )) });
}, Be = ue((g, C) => {
  const { namespace: o, href: d, focused: c, onHover: s = F } = g;
  return /* @__PURE__ */ t.jsx(
    Ue.Item,
    {
      ref: C,
      as: "a",
      href: d,
      target: "_parent",
      icon: /* @__PURE__ */ t.jsx(Ye, { namespace: o }),
      header: !0,
      content: He(o),
      variant: c ? "focused" : "default",
      onMouseOver: s
    }
  );
}), Lr = (g) => {
  const {
    entityTypeList: C,
    selectedEntityType: o = 0,
    getEntityTypeUrl: d = () => "",
    onHover: c = F
  } = g;
  return /* @__PURE__ */ t.jsx(G, { space: "none", children: C.map((s, u) => /* @__PURE__ */ t.jsx(
    Be,
    {
      namespace: s.namespace,
      focused: o === u,
      href: d(s.namespace),
      onHover: () => c(u)
    },
    s.namespace
  )) });
}, Ir = (g) => {
  const { onSearch: C, placeholder: o, value: d } = g, c = ie(null), s = k(
    (p) => {
      var v;
      p.key === "Escape" && (d === "" ? (v = c.current) == null || v.blur() : p.stopPropagation());
    },
    [d]
  ), u = br(
    () => wr(50, C),
    [C]
  ), h = k(
    (p) => {
      u(p);
    },
    [u]
  );
  return /* @__PURE__ */ t.jsx(
    Sr,
    {
      ref: c,
      type: "search",
      onChange: h,
      onKeyDown: s,
      value: d,
      maxWidth: "100%",
      magnitude: "xlarge",
      appearance: "bare",
      placeholder: o,
      autoFocus: !0,
      autoComplete: "off"
    }
  );
}, $r = ue((g, C) => {
  const { id: o, name: d = "", namespace: c, href: s, focused: u, onHover: h = F } = g;
  return Tr(o) ? /* @__PURE__ */ t.jsx(
    Be,
    {
      ref: C,
      namespace: c,
      href: s,
      focused: u,
      onHover: h
    }
  ) : /* @__PURE__ */ t.jsx(
    Ve,
    {
      ref: C,
      id: o,
      name: d,
      namespace: c,
      href: s,
      focused: u,
      onHover: h
    }
  );
}), Ur = (g) => {
  const {
    searchResultList: C,
    selectedSearchResult: o = 0,
    getSearchResultUrl: d = () => "",
    onHover: c = F
  } = g, s = ie(), u = ie();
  return Or(s, u), /* @__PURE__ */ t.jsx(G, { space: "none", children: C.map((h, p) => {
    const v = T(h.id) ? h.namespace : `${h.namespace}/${h.id}`;
    return /* @__PURE__ */ t.jsx(
      $r,
      {
        ref: o === p ? u : void 0,
        href: d(h.namespace, h.id),
        focused: o === p,
        id: h.id,
        name: h.name,
        namespace: h.namespace,
        onHover: () => c(p)
      },
      v
    );
  }) });
}, Wr = (g) => {
  const {
    onSearch: C = F,
    recentList: o = [],
    entityTypeList: d = [],
    searchResultList: c = [],
    getEntityUrl: s = () => "",
    getEntityTypeUrl: u = () => ""
  } = g, [h, p] = Ze(""), [v, y] = Ze(0), b = k(
    (x, E) => T(E) ? u(x) : s(x, E),
    [s, u]
  ), S = k(
    (x) => {
      p(x), C(x);
    },
    [p, C]
  ), A = k(
    (x) => {
      if (x.key === "ArrowDown")
        x.preventDefault(), (!T(c) && v < c.length - 1 || T(c) && v < o.length + d.length - 1) && y(v + 1);
      else if (x.key === "ArrowUp")
        x.preventDefault(), v > 0 && y(v - 1);
      else if (x.key === "Enter") {
        x.preventDefault();
        var E;
        if (T(c))
          if (v < o.length) {
            const O = o[v];
            E = s(O.namespace, O.id);
          } else {
            const O = d[v - o.length];
            E = u(O.namespace);
          }
        else {
          const O = c[v], X = "id" in O ? O.id : void 0;
          E = b(O.namespace, X);
        }
        E && (window !== parent ? parent.location.pathname = E : window.location.pathname = E);
      }
    },
    [
      v,
      c,
      o,
      d,
      s,
      u,
      b
    ]
  ), H = k(
    (x) => {
      y(x);
    },
    [y]
  ), J = k(
    (x) => {
      y(x);
    },
    [y]
  ), K = k(
    (x) => {
      y(x + (o.length ?? 0));
    },
    [y, o == null ? void 0 : o.length]
  );
  return _r(() => {
    y(0);
  }, [c]), /* @__PURE__ */ t.jsx("div", { style: { height: "100%" }, onKeyDown: A, children: /* @__PURE__ */ t.jsxs(We, { children: [
    /* @__PURE__ */ t.jsx(Pr, { border: !0, children: /* @__PURE__ */ t.jsx(Fe, { padding: "small", paddingMode: "equal", children: /* @__PURE__ */ t.jsx(
      Ir,
      {
        onSearch: S,
        placeholder: "Switch to…",
        value: h
      }
    ) }) }),
    /* @__PURE__ */ t.jsx(Ne, { children: /* @__PURE__ */ t.jsxs(Fe, { padding: "medium", paddingMode: "extended", children: [
      !T(c) && /* @__PURE__ */ t.jsx(
        Ur,
        {
          searchResultList: c,
          selectedSearchResult: v,
          getSearchResultUrl: b,
          onHover: H
        }
      ),
      T(h) && T(c) && /* @__PURE__ */ t.jsxs(G, { space: "medium", children: [
        !T(o) && /* @__PURE__ */ t.jsx(Ae, { children: "RECENT" }),
        !T(o) && /* @__PURE__ */ t.jsx(
          Ar,
          {
            entityList: o,
            selectedEntity: v,
            getEntityUrl: s,
            onHover: J
          }
        ),
        /* @__PURE__ */ t.jsx(Ae, { children: "SHORTCUTS" }),
        /* @__PURE__ */ t.jsx(
          Lr,
          {
            entityTypeList: d,
            selectedEntityType: v - o.length,
            getEntityTypeUrl: u,
            onHover: K
          }
        )
      ] }),
      !T(h) && T(c) && /* @__PURE__ */ t.jsx(Mr, { tone: "secondary", children: "No results" })
    ] }) })
  ] }) });
}, Br = (g) => {
  const {
    animation: C,
    width: o,
    height: d,
    minHeight: c,
    onClose: s,
    onSearch: u,
    recentList: h,
    entityTypeList: p,
    searchResultList: v,
    getEntityUrl: y,
    getEntityTypeUrl: b
  } = g, S = k(() => {
    u == null || u(""), s == null || s();
  }, [s, u]);
  return /* @__PURE__ */ t.jsx(
    kr,
    {
      animation: C,
      "aria-label": "App switcher",
      onClose: S,
      width: o,
      height: d,
      minHeight: c,
      children: /* @__PURE__ */ t.jsx(We, { children: /* @__PURE__ */ t.jsx(Ne, { children: /* @__PURE__ */ t.jsx(
        Wr,
        {
          onSearch: u,
          recentList: h,
          entityTypeList: p,
          searchResultList: v,
          getEntityUrl: y,
          getEntityTypeUrl: b
        }
      ) }) })
    }
  );
};
export {
  Ve as Entity,
  Ar as EntityList,
  Be as EntityType,
  Lr as EntityTypeList,
  Ye as NamespaceIcon,
  Ir as SearchInput,
  Wr as Switcher,
  Br as SwitcherModal
};
